import Vue from 'vue'
import Router from "vue-router";
import firebase from 'firebase';
import Userauth from '../auth/js/index'

import Body from '../components/body'
import Auth from '../auth/auth'

/* Auth */
import login from '../auth/login'
import callback from '../pages/callback'
import Register from '../auth/register'

/* maintenance */
import Maintenance from '../pages/maintenance'

/* Dashboards */
import Default from '../pages/dashboard/default'

//import FirebaseUser from '../pages/users/firebase_user'
import FirebaseIapLog from '../pages/firebase/iaplog'
import FirebaseNotice from '../pages/firebase/notice'
import FirebaseEmail from '../pages/firebase/email'
import FirebaseGift from '../pages/firebase/gift'
import FirebaseItem from '../pages/firebase/item'
import FirebaseRank from '../pages/firebase/rank'

/* User Profile */
import UserList from '../pages/firebase/user'
import UserProfile from '../pages/users/profile'
import UserEditProfile from '../pages/users/edit-profile'

/* Authentication */
import LoginOne from '../pages/authentication/login_one'
import LoginTwo from '../pages/authentication/login_two'
import LoginValidate from '../pages/authentication/login_with_validation'
import RegisterImage from '../pages/authentication/register_image'
import RegisterImage2 from '../pages/authentication/register_image2'
import Unlock from '../pages/authentication/unlock'
import ForgetPassword from '../pages/authentication/forget_password'
import ResetPassword from '../pages/authentication/reset_password'

// component

Vue.use(Router)

const routes = [
{ path: '', redirect: { name: 'default' }},
{
  path: '/dashboard',
  component: Body,
  meta: {
    requiresAuth: true
  },
  children: [
  {
    path: 'default',
    name: 'default',
    component: Default,
    meta: {
      title: 'Default Dashboard | ManoSDK Admin',
    }
  }
  ]
},
{
  path:'/users',
  component: Body,
  children:[
    {
      path: 'profile',
      name: 'UserProfile',
      component:UserProfile,
       meta: {
        title: 'serProfile | ManoSDK Admin',
      }
    },
    {
      path: 'edit',
      name: 'UserEditProfile',
      component:UserEditProfile,
       meta: {
        title: 'serEditProfile | ManoSDK Admin',
      }
    },
    {
      path: 'list',
      name: 'UserList',
      component:UserList,
       meta: {
        title: 'User List | ManoSDK Admin',
      }
    }
  ]
},
{
  path: '/app',
  component: Body,
  children: [
    

    {
      path: 'firebase-iaplog',
      name: 'FirebaseIapLog',
      component: FirebaseIapLog,
       meta: {
          title: 'FirebaseIapLog | ManoSDK Admin',
        }
    },      
    {
      path: 'firebase-notice',
      name: 'FirebaseNotice',
      component: FirebaseNotice,
       meta: {
          title: 'FirebaseNotice | ManoSDK Admin',
        }
    },     
    {
      path: 'firebase-email',
      name: 'FirebaseEmail',
      component: FirebaseEmail,
       meta: {
          title: 'FirebaseEmail | ManoSDK Admin',
        }
    },     
    {
      path: 'firebase-gift',
      name: 'FirebaseGift',
      component: FirebaseGift,
       meta: {
          title: 'FirebaseGift | ManoSDK Admin',
        }
    },     
    {
      path: 'firebase-item',
      name: 'FirebaseItem',
      component: FirebaseItem,
       meta: {
          title: 'FirebaseItem | ManoSDK Admin',
        }
    },    
    {
      path: 'firebase-rank',
      name: 'FirebaseRank',
      component: FirebaseRank,
       meta: {
          title: 'FirebaseRank | ManoSDK Admin',
        }
    }
  ]
},
{
  path: '/auth',
  component: Auth,
  children: [
  {
    path: 'login',
    name: 'Login 1',
    component: login,
    meta: {
      title: ' login | ManoSDK Admin',
    }
  },
  {
    path: 'register',
    name: 'register 1',
    component: Register,
    meta: {
      title: ' Register | ManoSDK Admin',
    }
  }
  ]
},
{
  path: '/callback',
  name: 'callback',
  component: callback,
  meta: {
      title: 'Auth0',
  }
},
{
  path:'/maintenance',
  name:'Maintenance',
  component:Maintenance,
  meta: {
      title: 'Maintenance | ManoSDK Admin',
    }
},
{
  path:'/authentication/login/one',
  name:'LoginOne',
  component:LoginOne,
  meta: {
      title: 'LoginOne | ManoSDK Admin',
    }
},
{
  path:'/authentication/login/two',
  name:'LoginTwo',
  component:LoginTwo,
  meta: {
      title: 'LoginTwo | ManoSDK Admin',
    }
},
{
  path:'/authentication/login/validate',
  name:'LoginValidate',
  component:LoginValidate,
  meta: {
      title: 'LoginValidate | ManoSDK Admin',
    }
},
{
  path:'/authentication/register/image',
  name:'RegisterImage',
  component:RegisterImage,
  meta: {
      title: 'RegisterImage | ManoSDK Admin',
    }
},
{
  path:'/authentication/register/image2',
  name:'RegisterImage2',
  component:RegisterImage2,
  meta: {
      title: 'RegisterImage2 | ManoSDK Admin',
    }
},
{
  path:'/authentication/unlockuser',
  name:'Unlock',
  component:Unlock,
  meta: {
      title: 'Unlock | ManoSDK Admin',
    }
},
{
  path:'/authentication/forgetpassword',
  name:'ForgetPassword',
  component:ForgetPassword,
  meta: {
      title: 'ForgetPassword | ManoSDK Admin',
    }
},
{
  path:'/authentication/resetpassword',
  name:'ResetPassword',
  component:ResetPassword,
  meta: {
      title: 'ResetPassword | ManoSDK Admin',
    }
},

];

const router = new Router({
  routes,
  base: '/',
  mode: 'history',
  linkActiveClass: "active",
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(() => {
    if(to.meta.title)
      document.title = to.meta.title;
    const CurrentUser = firebase.auth().currentUser;    
    const  path = ['/auth/login','/auth/register'];
    if (path.includes(to.path) || to.path === "/callback" || CurrentUser || Userauth.isAuthenticatedUser()){
      return next();
    }
    next('/auth/login')
  });
});

export default router
